import { GlobalButtonStyle } from '@website-builder/model/style/global-button-style';

export class OverlayButtonStyle extends GlobalButtonStyle {
  marginTop = 'uk-margin-top';
  transition = '';

  static normalize(styles: Partial<OverlayButtonStyle>): OverlayButtonStyle {
    const globalButtonStyle: GlobalButtonStyle = GlobalButtonStyle.normalize(styles);
    const pureStyles = new OverlayButtonStyle();

    Object.assign(pureStyles, globalButtonStyle);

    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;
    pureStyles.transition = styles.transition ?? pureStyles.transition;

    return pureStyles;
  }
}
